import { useState, useEffect, useContext } from "react";
import { PatrimonioContext } from "../../../contexts/patrimonioProvider";
import { UserContext } from "../../../contexts/userProvider";
import Cadastro from "./Types/cadastro";
import { BiTrash, BiPlus } from 'react-icons/bi';

const Modelo = (props) => {
    const { modelosByMarca, deleteModelo } = useContext(PatrimonioContext);
    const { setAlert } = useContext(UserContext);
    const [newModelos, setNewModelos] = useState([]);
    const [cadastroModal, setCadastroModal] = useState(false);
    const [modeloSelecionado, setModeloSelecionado] = useState(null);

    useEffect(() => {
        receberModelos();
    }, [props.marca]);

    const receberModelos = async () => {
        const dados = await modelosByMarca(props.marca.id);
        setNewModelos(dados);
    };

    const handleSelectModelo = (e) => {
        const { value } = e.target;
        const newModelo = newModelos.find((marca) => marca.id === parseInt(value));
        setModeloSelecionado(newModelo);
        props.setModelo(newModelo);
    };

    const handleAddModelo = () => {
        setCadastroModal(true);
    };

    const handleDeleteModelo = () => {
        if (!modeloSelecionado) return setAlert({ type: 'warning', message: 'Selecione uma marca para deletar!' })
        setAlert({
            type: 'confirm',
            placeholder: `Realmente deseja deletar a marca ${modeloSelecionado.nome}?`,
            visible: true,
            confirm: true,
            title: 'Atenção!',
            callback: () => deleteModelo(modeloSelecionado.id),
            params: modeloSelecionado.id
        })
    }

    return (
        <div className="space-y-4">
            <div className="flex items-end space-x-3">
                <div className="flex-1 space-y-2">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Modelo
                    </label>
                    <select
                        className="w-full px-4 py-3 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200"
                        onChange={handleSelectModelo}
                    >
                        <option value="">Selecione o modelo</option>
                        {newModelos &&
                            newModelos
                                .slice()
                                .sort((a, b) => a.nome.localeCompare(b.nome))
                                .map((marca, index) => (
                                    <option key={index} value={marca.id}>
                                        {marca.nome}
                                    </option>
                                ))}
                    </select>
                </div>
                
                <button
                    onClick={handleAddModelo}
                    className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-vox-green-500 to-vox-green-600 hover:from-vox-green-600 hover:to-vox-green-700 text-white rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
                    title="Adicionar Modelo"
                >
                    <BiPlus size={20} />
                </button>
            </div>

            {cadastroModal && (
                <Cadastro
                    fornecedor={props.fornecedor}
                    receberModelos={receberModelos}
                    setCadastroModal={setCadastroModal}
                    marca={props.marca}
                />
            )}
        </div>
    );
};

export default Modelo;
